import { useState, useMemo } from 'react'
import { ExpandMore, ExpandLess, Delete, Edit } from '@material-ui/icons'

import { Input, Select, Button } from '@baseV2'
import { displayAmount } from '@utils'
import { OTHER_CHARGES_INVOICE, strings } from '@constants'

import {
	BasicDetailsCard,
	CardHeader,
	CardTitle,
	HeaderRight,
	EditBtn,
	ChevronBtn,
	UpdateBtn,
	VehicleInputSection,
	VehicleInputGroup,
	VehicleInputLabel,
	IconActionBtn,
	AddBtn,
	ChargesList,
	ChargeRow,
	ChargeLabel,
	ChargeAmount,
} from './style'

const OtherChargesCard = ({
	editable = false,
	charges,
	addCharge,
	removeCharge,
	isEditMode,
	isSaving,
	isDirty,
	handleUpdate,
	enterEditMode,
	setIsEditMode,
}) => {
	const [isOpen, setIsOpen] = useState(true)
	const [selectedType, setSelectedType] = useState(null)
	const [amount, setAmount] = useState('')

	const labelFor = (key) => OTHER_CHARGES_INVOICE.find((c) => c.key === key)?.label ?? key

	// Hide charge types that have already been added so they can't be duplicated.
	const availableTypes = useMemo(() => OTHER_CHARGES_INVOICE.filter((c) => !(c.key in charges)), [charges])

	const handleAdd = () => {
		if (!selectedType?.key || amount === '') return
		addCharge(selectedType.key, amount)
		setSelectedType(null)
		setAmount('')
	}

	const chargeKeys = Object.keys(charges)

	return (
		<BasicDetailsCard>
			<CardHeader>
				<CardTitle>{strings('other', 'charges')}</CardTitle>
				<HeaderRight>
					{isEditMode ? (
						<>
							<Button variant='outline' type='danger' xs disabled={isSaving} onClick={() => setIsEditMode(false)}>
								{strings('cancel')}
							</Button>
							<UpdateBtn type='primary' xs disabled={isSaving || !isDirty} onClick={handleUpdate}>
								{isSaving ? 'Saving...' : strings('update')}
							</UpdateBtn>
						</>
					) : (
						editable && (
							<EditBtn onClick={enterEditMode}>
								<Edit fontSize='small' />
								{strings('edit')}
							</EditBtn>
						)
					)}
					<ChevronBtn onClick={() => setIsOpen((v) => !v)}>{isOpen ? <ExpandLess /> : <ExpandMore />}</ChevronBtn>
				</HeaderRight>
			</CardHeader>

			{isOpen && (
				<>
					{isEditMode && (
						<VehicleInputSection>
							<VehicleInputGroup>
								<VehicleInputLabel>{strings(['other', 'charge', 'type'])}</VehicleInputLabel>
								<Select
									small
									data={availableTypes}
									displayKey='label'
									primaryKey='key'
									placeholder={strings(['select', 'other', 'charge', 'type'])}
									value={selectedType}
									onChange={(v) => setSelectedType(v)}
								/>
							</VehicleInputGroup>
							<VehicleInputGroup>
								<VehicleInputLabel>{strings('charge', 'amount')}</VehicleInputLabel>
								<Input
									type='number'
									small
									min='0'
									placeholder={strings(['enter', 'charge', 'amount'])}
									value={amount}
									onChange={(e) => setAmount(e.target.value)}
								/>
							</VehicleInputGroup>
							<AddBtn type='primary' small disabled={!selectedType?.key || amount === ''} onClick={handleAdd}>
								{strings('add')}
							</AddBtn>
						</VehicleInputSection>
					)}

					{chargeKeys.length > 0 && (
						<ChargesList>
							{chargeKeys.map((key) => (
								<ChargeRow key={key}>
									<ChargeLabel>{labelFor(key)}</ChargeLabel>
									<ChargeAmount>{displayAmount(charges[key])}</ChargeAmount>
									{isEditMode && (
										<IconActionBtn onClick={() => removeCharge(key)}>
											<Delete fontSize='small' color='error' />
										</IconActionBtn>
									)}
								</ChargeRow>
							))}
						</ChargesList>
					)}
				</>
			)}
		</BasicDetailsCard>
	)
}

export default OtherChargesCard
